import { ExceptionEvent, Geotab, User } from "@fairfleet/geotab";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

async function addExceptionEventComment(props: {
  geotabClient: Geotab;
  comment: string;
  event: ExceptionEvent;
  me: User;
}) {
  const { comment, event, me, geotabClient } = props;
  const result = await geotabClient.call("Add", {
    typeName: "ExceptionEventComment",
    entity: { text: comment, exceptionEvent: event, dateTime: new Date(), user: { id: me.id } },
  });
  return result;
}

export function useAddExceptionEventComment() {
  const queryClient = useQueryClient();

  const { geotabClient } = useGeotabClient();
  return useMutation({
    mutationFn: async (props: { comment?: string; event: ExceptionEvent; me: User | null }) => {
      const { comment, me, event } = props;
      if (comment && me) {
        return addExceptionEventComment({ comment, event, me, geotabClient });
      }
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["exceptionEventComments"]
      }); // Invalidate cache to refresh comments
    }
  });
}
